module.exports = __webpack_public_path__ + "img/yanfa.7269f7c6.png";